
  <script>
  import Layout from "../../layouts/main";
  import Banner from "@/components/banner.vue"
  import NewsApi from "@/services/news-api";
  //import Navigation from "@/components/navigation.vue"

  export default ({
    name: "Catalogue",
  
    components: {
      Layout, Banner /*,Navigation*/
    },
  
    mounted() {
      this.getBlog()
       
    },
  
    data() {
      return {
        pagemodel: {currentPage : 1, perPage :9, totalRows: 0 , pageSize:0},
        blogsList:[] ,
        isLandingBlog : false,
        searchInput:null,
      }
    },

    watch:{
      searchInput: function(){
        this.getBlog();
      }
    },
  
    methods: {
      refresh(searchInput){
        this.searchInput = searchInput
      },

      goTopPage() {
        window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
      },

      getBlog(){

        this.isLandingBlog = true,
        NewsApi.getBlog(this.pagemodel.currentPage, this.pagemodel.perPage,this.searchInput ? this.searchInput : '' ).then(
          result => {
            this.blogsList = result.list ;
            this.pagemodel.totalRows = result.total;
            this.pagemodel.currentPage = result.page;
            this.pagemodel.perPage = result.pageSize;
            this.pagemodel.pageSize = result.pageSize;
            this.isLandingBlog = false

            this.goTopPage();
          }
        )    
        .finally(() => {
          this.isLandingBlog = false
          });

      }
  
      
        },
  
  
        
  });
  </script>
  
  <template>
    <Layout>
      <Banner pageTitle='News & Actualités' subtitle1="Découvrez les dernières tendances et actualités de la mode" :search="true" @refresh="refresh"></Banner>

      <!-- <Navigation ></Navigation> -->


      <div v-if="this.blogsList && this.blogsList.length >0 " class="row mt-4 blogs-height"   >
            <div class="col-12 col-md-6 col-lg-4 p-0 pt-5 p-md-4" v-for="blog in blogsList" :key="blog.id">
              <div class="pr-md-5">
                  <a :href="'/actualites/' + encodeURIComponent(blog.seoName)" > 
                    <img :src="`/api/image/get/${blog.image}`" class="card-img-top" alt="Image de l'article" height="330" style="cursor: pointer;">
                    <div class="card-text text-muted font-size-12 pt-2">{{ blog.dateStr }}</div>
                    <div class="text-left font-size-20 font-weight-bold pt-2">{{ blog.name }}</div>
                  </a>
          </div>
      </div>
      </div>

      <div v-else-if="searchInput && searchInput.length" class="col-12 text-center" style="min-height: 20em; margin-top: 100px; ">
           <span class="text-warning  font-size-16">Aucun blog ne correspond au mot clé de recherche <strong>{{ searchInput }}</strong> !
          </span>
      </div>

      <div v-else class="col-12 text-center" style="min-height: 20em; margin-top: 100px; ">
              <span class="text-warning  font-size-16">Nous n'avons pas encore publié des blogs. <br>Restez à l'écoute pour nos prochaines nouvelles !
            </span>
      </div>
      <b-spinner v-if="isLandingBlog" 
        variant="dark"
            small class="mr-2" ></b-spinner>

          <!-- Pagination -->

      <div v-if="this.blogsList && this.blogsList.length >0 " class="row m-5">
         <div class="col-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getBlog()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[9,18]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-4 text-right">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getBlog()" :disabled="isLandingBlog" ></b-pagination>
                    </ul>
                </div>
            </div>
      </div>
        <!-- Fin Pagination  -->
     
  
    </Layout>
  </template>
  


<style scoped>

@media (max-width: 767px) {

  .blogs-height {
    padding-left: 0px !important; 
    min-height: 0em!important; 
  }
}

.blogs-height {
  padding-left: 40px; 
  min-height: 70em;
}

  .getStarted {
    position: relative;
    letter-spacing: -0.4px;
    line-height: 28px;
    font-weight: 500;
  }
  
  .filter {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    text-align: left;
    font-size: 16px;
    color: #121212;
    font-family: Poppins;
    padding-left: 1.5%;
  }
  
  .iconsettings {
    position: relative;
    width: 20px;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
  }
  
  .buttonRow {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 16px;
    color: #121212;
    font-family: Poppins;
    padding-left: 1%;
    padding-right: 1%;
  }
  
  .sortText {
    font-weight: 500;
  }
  
  .sort {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    text-align: left;
    font-size: 16px;
    color: #121212;
    font-family: Poppins;
    padding-right: 1.5%;
  }
  
  .iconSort {
    position: relative;
    width: 20px;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
  }
  
  
  </style>
  